import _ from 'lodash';
import moment from 'moment';
import { getStepBySlug } from '../../../../utils/function';
import { FETCH_CHECK_STATUT_CONTRAT } from '../../../actions/app/checkContratStatut/checkContratStatut.actions';
import { setInit } from '../../../actions/app/init/init.actions';
import { setError, setLoader, setStep } from '../../../actions/app/ui/ui.actions';
import { API_ERROR, API_SUCCESS, apiRequest } from '../../../actions/core/api/api.actions';
import { analyticsSetEvent } from '../../../actions/core/analytics/analytics.actions.js';

/**
 * Construit l'event ecommerce `purchase` (dataLayer GTM/GA4).
 *
 * Depuis la bascule vers le SmartForm Sogecommerce embarqué (PR #70), le
 * paiement ne repasse plus par une redirection retour `?paid=1` : le purchase
 * historiquement poussé par init.middleware (guard `locationSearch.paid === '1'`)
 * ne part donc plus. On le ré-émet ici, au moment où le contrat est confirmé
 * (`state === 'contrat'`), seul instant où le `Contrat.Police` (transaction_id)
 * est disponible côté client.
 *
 * `data` a la même forme que la réponse init (cf init.middleware.js).
 */
const buildPurchaseEvent = (data) => {
    const personne = data?.data?.DemandeTarif?.ListePersonnes?.[0];

    return analyticsSetEvent({
        event: 'purchase',
        datas: {
            ecommerce: {
                currency: 'EUR',
                value: data.data.Devis.Formule.PrimeAnnuelleFracAnnuel,
                transaction_id: data.data.Contrat.Police || '-',
                coupon: data?.Tarif?.CodePromo?.Eligible ? data?.DemandeTarif?.CodePromo?.CodePromo : '',
                phoneNumber: personne?.TelPortable?.replace(/\s/g, ''),
                birthDate: personne?.DateNaissance ? moment(personne.DateNaissance, 'DD/MM/YYYY').format('YYYYMMDD') : null,
                firstName: _.toLower(personne?.Prenom),
                lastName: _.toLower(personne?.Nom),
                street: `${personne?.Adresse1 ?? ''}${personne?.Adresse2 ? ` ${personne.Adresse2}` : ''}`,
                zipCode: personne?.CP,
                city: _.lowerCase(personne?.Ville).replace(/\s/g, ''),
                items: [
                    {
                        item_name: `Assurance ${data.data.Devis.Vehicule.FamilleProduit}`,
                        price: data.data.Devis.Formule.PrimeAnnuelleFracAnnuel,
                        item_category: data.data.Devis.Vehicule.FamilleProduit,
                        item_variant: data.data.DemandeTarif.Police.FormuleChoisie,
                        quantity: '1',
                    },
                ],
            },
        },
    });
};

export const checkContratStatutMiddleware = () => (next) => (action) => {
    next(action);

    const { payload } = action;

    switch (action.type) {
        case FETCH_CHECK_STATUT_CONTRAT:
            next([
                apiRequest({ body: null, method: 'POST', url: payload.data, entity: FETCH_CHECK_STATUT_CONTRAT }),
                setLoader({ state: true, entity: FETCH_CHECK_STATUT_CONTRAT }),
            ]);

            break;

        case `${FETCH_CHECK_STATUT_CONTRAT} ${API_SUCCESS}`:
            if (payload.data.state === 'contrat') {
                /* Vérifie qu'une signature est en cours */
                const step =
                    payload.data.signatures.length > 0 &&
                    payload.data.signatures[0].refused === false &&
                    payload.data.signatures[0].signed === false &&
                    payload.data.signatures[0].started === false
                        ? getStepBySlug('signature')
                        : getStepBySlug('envoi-des-pieces');

                const contratActions = [
                    setInit({ init: payload.data }),
                    setStep({ step: step }),
                    setError({ state: false, entity: FETCH_CHECK_STATUT_CONTRAT }),
                    setLoader({ state: false, entity: FETCH_CHECK_STATUT_CONTRAT }),
                ];

                /* Purchase (SmartForm embarqué) : ne doit jamais bloquer la validation du contrat */
                if (payload.data?.data?.Devis && payload.data?.data?.Contrat) {
                    try {
                        contratActions.push(buildPurchaseEvent(payload.data));
                    } catch (e) {
                        console.error('[analytics] échec construction event purchase', e);
                    }
                }

                next(contratActions);
            } else {
                next([
                    setError({ state: false, entity: FETCH_CHECK_STATUT_CONTRAT }),
                    setLoader({ state: false, entity: FETCH_CHECK_STATUT_CONTRAT }),
                ]);
            }

            break;

        case `${FETCH_CHECK_STATUT_CONTRAT} ${API_ERROR}`:
            next([
                setError({ state: true, entity: FETCH_CHECK_STATUT_CONTRAT }),
                setLoader({ state: false, entity: FETCH_CHECK_STATUT_CONTRAT }),
            ]);
            break;

        default:
            return null;
    }
};
